import React from 'react';
import { motion } from 'framer-motion';

// You can import these icons from a library like 'lucide-react'
// For this example, I'll use simple inline SVGs.
const LeadershipIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 12s2.5-8 4.5-8 4.5 8 4.5 8-2.5 8-4.5 8-4.5-8-4.5-8z" /><path d="M12 12L6 6" /><path d="M12 12l-6 6" /></svg>
);
const ActionIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 14c.2-1 .7-1.7 1.5-2.5C17.7 10.2 19 9 19 7c0-2.2-1.8-4-4-4S11 4.8 11 7c0 2 1.3 3.2 2.5 4.5.8.8 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>
);
const SkillIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
);
const NetworkIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v4a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4Z"/><path d="M12 12v4"/><path d="M12 2v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m4.93 19.07 1.41-1.41"/><path d="m17.66 6.34 1.41-1.41"/></svg>
);


const App = () => {
  const details = [
    {
      icon: <LeadershipIcon />,
      title: "Campus Leadership",
      text: "Lead value-driven initiatives and inspire peers on your campus.",
    },
    {
      icon: <ActionIcon />,
      title: "Purpose in Action",
      text: "Convert ethical ideals into real change through events.",
    },
    {
      icon: <SkillIcon />,
      title: "Skill & Impact on you",
      text: "Develop leadership, communication skills that matter.",
    },
    {
      icon: <NetworkIcon />,
      title: "National Network",
      text: "Collaborate with passionate students across India.",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  return (
    <>
      <div className="particles-container">
          {[...Array(20)].map((_, i) => (
              <div 
                  key={i}
                  className="particle"
                  style={{
                      left: `${Math.random() * 100}%`,
                      width: `${Math.random() * 3 + 1}px`,
                      height: `${Math.random() * 3 + 1}px`,
                      animationDelay: `${Math.random() * 25}s`,
                      animationDuration: `${Math.random() * 15 + 10}s`
                  }}
              />
          ))}
      </div>
      <motion.section 
        className="ambassador-section"
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <motion.h1 className="main-title" variants={itemVariants}>
          Become Our Campus Ambassador
        </motion.h1>

        <motion.div className="detail-box-container" variants={itemVariants}>
          <motion.div 
            className="image-container-premium"
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <img 
              src="/assets/Campus_Ambassador/campus_ambassador.jpg"
              alt="Campus Ambassador Program"
            />
          </motion.div>
          
          <motion.div 
            className="details-grid" 
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            onMouseMove={(e) => {
              const cards = document.querySelectorAll('.detail-card');
              cards.forEach(card => {
                  const rect = card.getBoundingClientRect();
                  const x = e.clientX - rect.left;
                  const y = e.clientY - rect.top;
                  card.style.setProperty('--x', `${x}px`);
                  card.style.setProperty('--y', `${y}px`);
              });
            }}
          >
            {details.map((item, index) => (
              <motion.div key={index} className="detail-card" variants={itemVariants}>
                <div className="card-heading" >
                  <div className="card-icon">{item.icon}</div>
                  <h3 className="card-title">{item.title}</h3>
                </div>
                <p className="card-text">{item.text}</p>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </motion.section>
    </>
  );
};

export default App;
